import { render } from "./reportsandstats.vue?vue&type=template&id=d7320cce&scoped=true"
import script from "./reportsandstats.vue?vue&type=script&lang=js"
export * from "./reportsandstats.vue?vue&type=script&lang=js"

import "./reportsandstats.vue?vue&type=style&index=0&id=d7320cce&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7320cce"]])

export default __exports__